/**
 * Trustwave Trusted Commerce seal URLs (Angular payment / company parity).
 * @see payment-info-capture.component.html, company-edit.component.html
 */

export const TRUSTWAVE_SEAL = {
  BASE_URL: 'https://sealserver.trustwave.com',
  CUSTOMER_ID: '85d2576a9b7743cda745f223d440c721',
  STYLE: 'invert',
  SIZE: '105x54',
} as const

const sealImageQuery = `customerId=${TRUSTWAVE_SEAL.CUSTOMER_ID}&size=${TRUSTWAVE_SEAL.SIZE}&style=${TRUSTWAVE_SEAL.STYLE}`

/** Fully qualified Trustwave seal endpoints. */
export const TRUSTWAVE_SEAL_URLS = {
  sealScript: `${TRUSTWAVE_SEAL.BASE_URL}/seal.js?style=${TRUSTWAVE_SEAL.STYLE}&code=${TRUSTWAVE_SEAL.CUSTOMER_ID}`,
  sealImage: `${TRUSTWAVE_SEAL.BASE_URL}/seal_image.php?${sealImageQuery}`,
  certPopup: `${TRUSTWAVE_SEAL.BASE_URL}/cert.php?${sealImageQuery}`,
} as const

export const TRUSTWAVE_SEAL_ALT =
  "This site is protected by Trustwave's Trusted Commerce program"

export const TRUSTWAVE_CONTEXT_MENU_MESSAGE =
  'Copying Prohibited by Law - Trusted Commerce is a Service Mark of TrustWave Holdings, Inc.'

export const TRUSTWAVE_CERT_POPUP_WINDOW_NAME = 'c_TW'

export const TRUSTWAVE_CERT_POPUP_FEATURES =
  'location=no, toolbar=no, resizable=yes, scrollbars=yes, directories=no, status=no, width=615, height=720'
